import { useIntl } from 'react-intl'

import JobInfoAddHome from './JobInfoAddHome'
import JobInfoDetails from './JobInfoDetails'
import JobInfoNotes from './JobInfoNotes'
import JobInfoImages from './JobInfoImages'
import JobInfoHeader from './JobInfoHeader'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { JobInfoContainer } from './styles'
import { HomeConfigFiles } from 'features/home/components'
import { jobInfoMessages } from './messages'

interface JobInfoProps {
  hasHome?: boolean
}

function JobInfo({ hasHome = false }: JobInfoProps) {
  const { formatMessage } = useIntl()

  return (
    <StyledFadeInWrapper>
      <JobInfoHeader />

      <JobInfoContainer>
        {!hasHome && <JobInfoAddHome />}
        <HomeConfigFiles
          selector="notMatching"
          title={formatMessage(jobInfoMessages.jobFilesTableTitle)}
        />
        <JobInfoDetails />
        <JobInfoNotes />
        <JobInfoImages />
      </JobInfoContainer>
    </StyledFadeInWrapper>
  )
}

export default JobInfo
